import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * LoadingSpinner component - Displays a centered loading spinner with optional message
 *
 * @param {boolean} fullScreen - If true, spans full viewport height
 * @param {string} message - Optional loading message to display below spinner
 * @param {string} size - Size of the spinner ('small', 'medium', 'large')
 * @returns {JSX.Element} Loading spinner component
 */
function LoadingSpinner({ fullScreen = false, message = '', size = 'medium' }) {
	const sizeMap = {
		small: 30,
		medium: 40,
		large: 60,
	};

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				height: fullScreen ? '100vh' : '100%',
				minHeight: fullScreen ? 'unset' : '200px',
				gap: 2,
			}}
		>
			<CircularProgress size={sizeMap[size]} />
			{message && (
				<Typography variant="body2" color="text.secondary">
					{message}
				</Typography>
			)}
		</Box>
	);
}

LoadingSpinner.propTypes = {
	fullScreen: PropTypes.bool,
	message: PropTypes.string,
	size: PropTypes.oneOf(['small', 'medium', 'large']),
};

export default LoadingSpinner;
